import React from 'react';
import ProgramTabDashboardIbp from './program-tab-ibp';

const GdoTabs = (props: any) => {
  const handleBulkUploadClick = () => {
    console.log('Bulk upload clicked');
  };

  return (
    <ProgramTabDashboardIbp
      breadcrumbPrefixLabel="All GDOs"
      breadcrumbLink="/data-pipeline/programOps/IBP/markets/ibpDashboard"
      showUploadAction={true}
      onUploadClick={handleBulkUploadClick}
      {...props}
    />
  );
};

export default GdoTabs;
